<template>
  <section>
    <div
      v-if="solicData.status === 'Não iniciada'"
      class="no-driver-container"
    >
      <div class="no-driver-card">
        <v-avatar
          size="70"
          color="#FF62001A"
          class="mb-3"
        >
          <v-icon
            size="35"
            color="#FF821A"
          >
            {{ icons.mdiAlertCircleOutline }}
          </v-icon>
        </v-avatar>
        <h3 class="no-driver-title">
          Solicitação fora da etapa de checklist
        </h3>
        <p class="no-driver-subtitle">
          Esta etapa será liberada assim que o status for alterado para "Em Checklist".
        </p>
      </div>
    </div>
    <div
      v-else
      class="checklist-tab"
    >
      <div style="display: flex; flex-direction: column; gap: 16px;">
        <article
          v-if="solicData.is_child"
          class="painel-info"
          style="border: 1px solid #FFB4001A;"
        >
          <v-icon
            color="#FFB400"
            size="24"
          >
            {{ icons.mdiAlertCircleOutline }}
          </v-icon>
          <div>
            <span
              class="painel-info-text"
              style="display: block; padding-bottom: 14px;"
            >
              O checklist não pode ser preenchido aqui!
            </span>
            <span
              style="display: inline; font-weight: 500; font-size: 14px;"
            >O checklist pode apenas ser visualizado nesta solicitação, pois ela é uma solicitação filha. O preenchimento do checklist deve ser realizado na solicitação pai, responsável por gerenciar todos os vínculos. {{ " " }}</span>
            <div
              class="go-to-parent-link"
              style="display: inline-flex; gap: 1px; align-items: center; cursor: pointer;"
              @click="goToParentSolicitation"
            >
              <span style="color: #0085FF; font-weight: 500;">
                Ir para a solicitação pai desta solicitação
              </span>
              <v-icon
                color="#0085FF"
              >
                {{ icons.mdiArrowTopRight }}
              </v-icon>
            </div>
          </div>
        </article>
        <DepartureChecklistComponent
          :solic-data="solicData"
          :is-child="solicData.is_child"
          @start-departure-checklist="handleStartDepartureChecklist"
          @checklist-data-loaded="handleDepartureChecklistDataLoaded"
          @checklist-approved="handleChecklistReviewed"
          @checklist-disapproved="handleChecklistReviewed"
        />
        <ArrivalChecklistComponent
          :solic-data="solicData"
          :is-child="solicData.is_child"
          :departure-completed="isDepartureChecklistCompleted"
          @start-arrival-checklist="handleStartArrivalChecklist"
          @checklist-approved="handleChecklistReviewed"
          @checklist-disapproved="handleChecklistReviewed"
        />
        <article
          v-if="solicData.is_child"
          class="painel-info"
          style="border: 1px solid #0085FF1A;"
        >
          <div>
            <span
              style="font-size: 15px; font-weight: 600; color: #E7E3FC;"
            >
              💡 <strong style="font-weight: 700;">Dica:</strong> Todas as solicitações vinculadas compartilham o mesmo checklist da solicitação pai.
            </span>
          </div>
        </article>
      </div>

      <div class="actions-area mt-4">
        <slot name="actions"></slot>
      </div>
    </div>
  </section>
</template>

<script>
import {
  mdiAccountAlertOutline,
  mdiAlertCircleOutline,
  mdiArrowLeft,
  mdiArrowTopRight,
  mdiCheckCircleOutline,
  mdiPlay,
} from '@mdi/js'
import ArrivalChecklistComponent from './checklist/ArrivalChecklistComponent.vue'
import DepartureChecklistComponent from './checklist/DepartureChecklistComponent.vue'

export default {
  name: 'ChecklistTab',
  components: {
    DepartureChecklistComponent,
    ArrivalChecklistComponent,
  },
  props: {
    solicData: {
      type: Object,
      default: () => ({}),
    },
    usersList: {
      type: Array,
      default: () => [],
    },
    vehiclesList: {
      type: Array,
      default: () => [],
    },
    driversList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      icons: {
        mdiAccountAlertOutline,
        mdiArrowLeft,
        mdiPlay,
        mdiCheckCircleOutline,
        mdiAlertCircleOutline,
        mdiArrowTopRight,
      },
      isDepartureChecklistCompleted: false,
    }
  },
  methods: {
    goToParentSolicitation() {
      if (!this.solicData.parent_id) {
        this.$swal({
          icon: 'warning',
          title: 'Aviso',
          text: 'Não foi possível identificar a solicitação pai.',
        })

        return
      }

      this.$emit('open-parent-solicitation', this.solicData.parent_id)
    },
    handleDepartureChecklistDataLoaded(checklistData) {
      this.isDepartureChecklistCompleted = checklistData && checklistData.items_completed === true
    },
    handleChecklistReviewed() {
      this.$emit('updateTable')
      this.$emit('close')
    },
    handleStartDepartureChecklist() {
      this.$emit('start-departure-checklist')
    },
    handleStartArrivalChecklist() {
      this.$emit('start-arrival-checklist')
    },
    goBackToSolicitation() {
      this.$emit('go-back-tab')
    },
  },
}
</script>

<style scoped>
.checklist-tab {
  color: #E7E3FC;
  width: 100%;
}

.actions-area {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.no-driver-container {
  color: #E7E3FC;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  width: 100%;
}

.no-driver-card {
  border-radius: 12px;
  padding: 40px 32px;
  text-align: center;
  max-width: 500px;
  width: 100%;
}

.no-driver-title {
  color: #FF821A;
  font-weight: 600;
  font-size: 24px;
  margin-bottom: 8px;
}

.no-driver-subtitle {
  color: #B8B5D1;
  font-size: 15px;
  line-height: 1.5;
  margin-bottom: 0;
  font-weight: semibold;
}

.no-driver-actions {
  display: flex;
  justify-content: center;
}
.painel-info {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  padding: 10px;
  border-radius: 5px;
}
.painel-info-text {
  font-size: 14px;
  font-weight: 600;
}

.go-to-parent-link {
  transition: all 0.2s ease;
}

.go-to-parent-link:hover {
  transform: translateX(3px);
  opacity: 0.8;
}
</style>
